import Os from "../../Os/Os";
import DateTime from "../../DateTime/DateTime";
import Cookies from "../../Cookies/Cookies";
import ColourScheme from "../../ColourScheme/ColourScheme";

function BottomColumns() {
    return (
        <div className="bottom-columns">
            <div className="bottom-columns__wrapper">
                <div className="column"><Cookies/></div>
                <div className="column"><ColourScheme/></div>
                <div className="column"><DateTime/></div>
            </div>
        </div>
    );
}

export default BottomColumns;